module.exports = __webpack_public_path__ + "static/media/IMG_5759.acc5cc3d.jpg";